<template>
    <div>
        <loading :active.sync="loadingContent" :can-cancel="false" :is-full-page="true" :color="'#0B8BCC'" :loader="'dots'" :opacity="0.7" :lock-scroll="true"></loading>
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <a href="Javascript:;" class="headerButton" @click="$router.go(-1)">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Kebijakan Privasi</div>
        </div>
        <div id="appCapsule">
            <div class="section inset m-1 mt-4">
                <privacy-policy></privacy-policy>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    data() {
        return {
            loadingContent: true
        }
    },
    created(){
        setTimeout(() => this.loadingContent = false, 500)
    },
    computed:{
        ...mapState(['VUE_ENV'])
    }
}
</script>